module.exports = __webpack_public_path__ + "img/objArrowDown.fa818fd7.svg";